import { Button } from '@/components/shadcn/button'
import { TooltipButton } from '@/components/ui/TooltipButton'
import { IconV2ArrowRightOutline } from '@icons/IconV2ArrowRightOutline'
import { IconV2ArrowLeftOutline } from '@icons/IconV2ArrowLeftOutline'
import clsx from 'clsx'
import { motion } from 'motion/react'

const MotionButton = motion(Button)

export function SidebarToggleButton({
  onToggle,
  open,
  disabled = false,
  variant = 'overlay',
}: {
  onToggle: () => void
  open: boolean
  disabled?: boolean
  variant?: 'overlay' | 'footer'
}) {
  const button = (
    <MotionButton
      layout
      variant="ghost"
      size={open ? 'default' : 'icon'}
      className={clsx({
        'absolute bottom-3 right-1 z-50': variant === 'overlay',
        'ml-auto mr-3 shrink-0': variant === 'footer',
      })}
      onClick={onToggle}
      aria-label="Toggle sidebar"
      disabled={disabled}
    >
      <IconV2ArrowRightOutline className={clsx('size-4', { hidden: open })} />
      <span className={!open ? 'hidden' : ''}>
        Collapse
        <IconV2ArrowLeftOutline className="ml-3 inline-block size-4" />
      </span>
    </MotionButton>
  )

  if (disabled) {
    return (
      <TooltipButton tooltip="Sidebar stays expanded on this page">
        <span>{button}</span>
      </TooltipButton>
    )
  }

  return <TooltipButton tooltip={open ? 'Collapse sidebar' : 'Expand sidebar'}>{button}</TooltipButton>
}
